import { usePartner } from '@@partner:helpers/hooks/auth'
import React from 'react'
import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'

import './CommonTopMenu.scss'


export type TopMenuElement = {
  icon: any
  to: string
  toParams?: Record<string, any>
  title: string
}

export type CommonTopMenuProps = {
  elements: TopMenuElement[]
}

export default function CommonTopMenu ({ elements }: CommonTopMenuProps) {
  const { brandSlug } = usePartner()

  return (
    <Navbar>
      <Nav>
        {elements.map((element, index) => (
          <Nav.Item
            key={index}
            icon={element.icon}
            as={NavLink}
            to={generatePath(element.to, { brandSlug, ...(element.toParams ?? {}) })}
            activeClassName='TopMenu__Item__Active'
          >{element.title}</Nav.Item>
        ))}
      </Nav>
    </Navbar>
  )
}